module.exports = ".map {\n  height: 600px;\n  width: 100%;\n  border: 1px solid lightgray;\n  margin-top: 5px; }\n\nlabel {\n  overflow-x: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/locations-map/locations-map.component.scss
// module id = ./src/app/shared/locations-map/locations-map.component.scss
// module chunks = main